import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import 'flatpickr/dist/flatpickr.css'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {bankPaymentOrderCompleteBankOrder} from '../../redux/slices/bankpaymentorder.slice'
import {bankCashAccountGetAll} from '../../redux/slices/lookup.slice'
import {Select} from '..'

const BankPaymentOrderCompleteBankOrder = ({BankPaymentOrderId, BankPaymentOrderItemIds}) => {
  const intl = useIntl()

  const {accountLookupList} = useSelector((state) => state.lookup)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(bankCashAccountGetAll())
  }, [])

  const validSchema = Yup.object().shape({
    AccountId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
  })

  const [formValues] = useState({
    BankPaymentOrderId,
    AccountId: '',
    BankPaymentOrderItemIds,
  })

  const formik = useFormik({
    initialValues: formValues,
    validationSchema: validSchema,
    onSubmit: async (values, {setSubmitting, resetForm}) => {
      setSubmitting(true)
      dispatch(bankPaymentOrderCompleteBankOrder(values))
      resetForm()
    },
  })

  useEffect(() => {
    formik.setFieldValue('BankPaymentOrderItemIds', BankPaymentOrderItemIds)
  }, [BankPaymentOrderItemIds])

  return (
    <>
      <form className='form position-relative' onSubmit={formik.handleSubmit} noValidate>
        <div className='row mb-6'>
          <label className='col-lg-12 fw-bold fs-6 mb-2'>
            {intl.formatMessage({id: 'BANKPAYMENTORDER.GET.COMPLETEBANKORDER.ACCOUNTID'})}
          </label>
          <div className='col-lg-12 fv-row fv-plugins-icon-container'>
            <Select
              data={accountLookupList}
              required
              {...formik.getFieldProps('AccountId')}
              onChange={(item) => formik.setFieldValue('AccountId', Number(item?.value))}
            />
          </div>
        </div>

        <div className='text-center'>
          <button
            type='submit'
            className='btn btn-primary'
            data-kt-users-modal-action='submit'
            disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>{intl.formatMessage({id: 'BUTTON.SUBMIT'})}</span>
            {formik.isSubmitting && (
              <span className='indicator-progress'>
                {intl.formatMessage({id: 'PLEASE'})}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>
    </>
  )
}

BankPaymentOrderCompleteBankOrder.propTypes = {
  collapse: PropTypes.bool,
}

export {BankPaymentOrderCompleteBankOrder}
